import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import titleMixin from '@/plugins/titleMixin'

loadFonts()

createApp(App).use(router)
  .use(vuetify)
  .mixin(titleMixin)
  .mount('#app')
